module.exports = __webpack_public_path__ + "e2d0e742c4f73bdca3194be0597f7bbb.png";